var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_308_298)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.85,
    cy: 9.41675,
    r: 9,
    fill: "#FFD600"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3679 28.5392C15.0524 28.5392 18.85 24.7417 18.85 20.0571C18.85 15.3726 15.0524 11.5751 10.3679 11.5751C5.68341 11.5751 1.88586 15.3726 1.88586 20.0571C1.88586 24.7417 5.68341 28.5392 10.3679 28.5392Z",
    stroke: "white",
    strokeWidth: 2.42345,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77548 27.1941L4.3093 38.2329L10.3679 34.5977L16.4265 38.2329L14.9603 27.1819",
    stroke: "white",
    strokeWidth: 2.42345,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.264 11.4071C25.9217 10.8385 26.439 10.3726 26.8158 10.0095C27.1995 9.63952 27.5181 9.25586 27.7715 8.8585C28.025 8.46113 28.1518 8.06376 28.1518 7.6664C28.1518 7.25533 28.0524 6.93333 27.8538 6.70039C27.6619 6.46745 27.3571 6.35098 26.9391 6.35098C26.5349 6.35098 26.2198 6.48116 25.9937 6.7415C25.7744 6.99499 25.658 7.33755 25.6443 7.76917H24.5138C24.5344 6.98814 24.7673 6.39209 25.2126 5.98102C25.6648 5.5631 26.2369 5.35415 26.9289 5.35415C27.6756 5.35415 28.258 5.55968 28.6759 5.97075C29.1007 6.38181 29.313 6.9299 29.313 7.61502C29.313 8.1083 29.1863 8.58445 28.9328 9.04348C28.6862 9.49565 28.3881 9.90329 28.0387 10.2664C27.6962 10.6227 27.2577 11.0372 26.7233 11.5099L26.2609 11.9209H29.5186V12.8972H24.5241V12.0443L25.264 11.4071Z",
    fill: "#0A0101"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_308_298",
    x: 13.0006,
    y: 0.416748,
    width: 29.6988,
    height: 29.6988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.84941
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.92471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_298",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.008b59c00048641dfb6dca59e28bf7eb.svg";
export { ForwardRef as ReactComponent };